var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { styled } from 'styled-components';
import { Scheduled } from './scheduled/Scheduled';
import { Active } from './active/Active';
import { Completed } from './completed/Completed';
import { Canceled } from './canceled/Canceled';
var Container = styled.ul.withConfig({ displayName: "Container", componentId: "sc-rvoj0u" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > li:not(:last-child) {\n    margin-bottom: 24px;\n  }\n"], ["\n  & > li:not(:last-child) {\n    margin-bottom: 24px;\n  }\n"])));
var Challenges = function (_a) {
    var _b = _a.marathons, marathons = _b === void 0 ? [] : _b, groupId = _a.groupId, schoolId = _a.schoolId, currentTeacherId = _a.currentTeacherId, onMarathonCancel = _a.onMarathonCancel, onMarathonEdit = _a.onMarathonEdit, rest = __rest(_a, ["marathons", "groupId", "schoolId", "currentTeacherId", "onMarathonCancel", "onMarathonEdit"]);
    return (_jsx(Container, __assign({}, rest, { children: marathons.map(function (_a) {
            var type = _a.type, props = __rest(_a, ["type"]);
            var leaderBoardPath = groupId
                ? "/teachers/g/" + groupId + "/challenges/" + props.id + "/leaderboard"
                : "/administrators/schools/" + schoolId + "/challenges/" + props.id + "/leaderboard";
            var isScheduled = type === 'scheduled' && onMarathonCancel && onMarathonEdit;
            if (isScheduled)
                return (_createElement(Scheduled, __assign({}, props, { key: props.id, onCancel: onMarathonCancel, onEdit: onMarathonEdit })));
            if (type === 'active')
                return (_createElement(Active, __assign({}, props, { key: props.id, currentTeacherId: currentTeacherId, leaderBoardPath: leaderBoardPath })));
            if (type === 'completed') {
                var certificateUrl = groupId
                    ? "/reports/marathon-student-certificate/pdf?marathonId=" + props.id + "&role=teacher"
                    : "/reports/marathon-teacher-certificate/pdf?marathonId=" + props.id;
                return (_createElement(Completed, __assign({}, props, { key: props.id, currentTeacherId: currentTeacherId, certificateUrl: certificateUrl, leaderBoardPath: leaderBoardPath })));
            }
            return _createElement(Canceled, __assign({}, props, { key: props.id }));
        }) }), void 0));
};
export { Challenges };
var templateObject_1;
